import React, { useState } from 'react'
import { useAppData } from '../../../../../../context/AppDataContext'
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import grievanceServices from '../grievanceServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { ArrowDropDown } from '@mui/icons-material';

function GrievanceStatusUpdate({grievanceDetails,callBack}) {
  const {masters,getMasterLabel} = useAppData();
  const [dialogStatus,setDialogStatus] = useState(false);
  const {AppAlert} = useAlert();

  const updateStatus = (grievanceStatus) =>{
    let payload = {
      id:grievanceDetails.id,
      grievanceStatus:grievanceStatus
    }
    grievanceServices.save(payload).then(res=>{
      AppAlert("Status Updated");
      callBack();
    }).catch(error=>{
      AppAlert(error.msg, "error");
    }).finally(()=>{
      setDialogStatus(false);
    })
  }

  return (
    <>
      <Dialog
        open={dialogStatus}
        keepMounted
        onClose={()=>setDialogStatus(false)}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle>Update Status</DialogTitle>
        <DialogContent>
          <div className='row mt-3'>
            <div className='col-md-12'>
              {masters['grievance-status'].map(grievanceStatus=>
                <button className='btn btn-outline-primary me-3 mb-3' onClick={()=>updateStatus(grievanceStatus.value)} >{grievanceStatus.label}</button>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <div className='p-2'>
          <div className='fw-bold mb-3'>
            <span className='me-2'>Grievance Status </span>
            <button className='btn btn-primary' onClick={()=>setDialogStatus(true)} >{getMasterLabel("grievance-status",grievanceDetails.grievanceStatus)} <ArrowDropDown/> </button>
          </div>

      </div>
      
    </>
  )
}

export default GrievanceStatusUpdate